Jelly.References = 
{
	// List of simple types.
	// TODO - fix order here. 
	Simple_Types:  Simple_Types,
	
	// List of all references by id
	// TODO - Secondary path dependencies is a temporary placeholder - it gets triggered on load of the primary path dependency, that's all. hm.
	Reference_Lookups_By_Kind: {
			"Item": {}, 
			"Iterator": {},
			"URL": [],
			"Specific": {
					"Container": {
							"Item": null,
							"Dependencies": []
						},
					"Site": {
							"Item": null,
							"Dependencies": []
						},
					"Path": {
							"Dependencies": {
									"Primary": null,
									"Secondary": []
								}
						}
				}
		},

	// List of all references by namespace
	References_By_Namespace: {},
	
	// Queue of references to be refreshed.
	References_To_Refresh: {},
	
	// When true, prevents registrations via the Register call.
	// TODO: Doesn't seem to do anything....
	No_Register: false,
	
	// Incrementing index of global references, updated by Create_Global_Reference.
	Current_Global_Reference_Index: 0,
	
	// Container progress bar
	Container_Progress_Bar: null,
	Container_Progress_Bar_Interval: null
};